import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

import LazyCallBack from '~/src/components/LazyCallBack';
import SpeedLine from '~/src/features/internetV2/components/SpeedLine';
import getSpeedLineItems, { TGetSpeedLineItemsReturnType } from '~/src/features/request/helpers/getSpeedLineItems';
import { TState } from '~/src/store';
import { selectAllTariffs } from '~/src/store/selectors/filteredBundles';

const SpeedLineContainer = (): JSX.Element => {
    const { allTariffs, isAuth } = useSelector((state: TState) => ({
        allTariffs: selectAllTariffs(state),
        isAuth: state.auth.isAuth,
    }));

    const speedLineItems = useMemo<TGetSpeedLineItemsReturnType>(
        () => getSpeedLineItems(allTariffs, false),
        [allTariffs],
    );

    return (
        speedLineItems
            ? (
                <SpeedLine
                    items={speedLineItems}
                    isAuth={isAuth}
                />
            )
            : (
                <LazyCallBack
                    tariffName={'internet'}
                    requestDataParams={{ product_id: [EProductsId.internet] }}
                    withPopupResult={true}
                    title={'Оставьте заявку в один клик'}
                    description={<></>}
                />
            )
    );
};

export default SpeedLineContainer;
